import React, { useRef } from "react"
import { Sky } from "drei"
// import { useControl } from "react-three-gui"
// import { useFrame } from "react-three-fiber"

function SkyComponent(props) {
  const sky = useRef()

  const inclination = 0.0
  //  useControl("inclination (солнце)", {
  //   type: "number",
  //   value: 0.00,
  //   min: 0,
  //   max: 1,
  // })
  const azimuth = 0.25
  // useControl("azimuth (солнце)", {
  //   type: "number",
  //   value: 0.25,
  //   min: 0,
  //   max: 1,
  // })

  let distance = 45000

  var theta = Math.PI * (inclination - 0.5)
  var phi = 2 * Math.PI * (azimuth - 0.5)

  const sunPosition = [
    distance * Math.cos(phi),
    distance * Math.sin(phi) * Math.sin(theta),
    distance * Math.sin(phi) * Math.cos(theta),
  ]

  return (
    <Sky
      ref={sky}
      // distance={450000} // Camera distance (default=450000)
      sunPosition={sunPosition} // Sun position normal (default=[0, 1, 0])
      // sunPosition={[0,12564.303631251329,-399802.6241462926]} // Sun position normal (default=[0, 1, 0])
      // sunPosition={[0, 1, 0]} // Sun position normal (default=[0, 1, 0])
      {...props} // All three/examples/jsm/objects/Sky props are valid
    />
  )
}

export default SkyComponent
